// vue3-popper ships dist/popper.ssr.js (its "main" entry, used for SSR) pre-transpiled with an old
// Babel target that expects a global `regeneratorRuntime` instead of bundling its own polyfill.
// Vite doesn't provide one, so any component rendering <Popper> (e.g. ProductCard's premium-tier
// price tooltip) crashes both server and client with "regeneratorRuntime is not defined". Must run
// before any component using vue3-popper, on both server and client - hence the 0. prefix and no
// .client/.server suffix. The import is assigned (not a bare side-effect import) so Rollup/Vite
// can't tree-shake it away as an unused import.
import regeneratorRuntime from 'regenerator-runtime/runtime'

export default defineNuxtPlugin(() => {
    if (typeof (globalThis as any).regeneratorRuntime === 'undefined') {
        ;(globalThis as any).regeneratorRuntime = regeneratorRuntime
    }
})
